export const state = () => ({
  keyword: '',
});
export const mutations = {
  setKeyword(state, keyword) { state.keyword = keyword; }
};
